import { fetcher } from 'src/config/request';
import { ClassEndpoints } from 'src/core/services/classes/endpoints';
export const ClassService = {
    async getClasses(classHashIds) {
        const { data } = await fetcher.get(ClassEndpoints.getClasses(), {
            params: { id: classHashIds }
        });
        return data.map((classItem) => ({
            ...classItem,
            name: classItem.name === 'membership.default.class.name' ? null : classItem.name
        }));
    }
};
